import { gql } from '@apollo/client'

export const STRATEGY_HISTORY_ITEM_QUERY = gql`
  query ($owner: String, $strategyId: Int, $first: Int, $skip: Int) {
    strategyUserHistoryItems(
      first: $first
      skip: $skip
      where: { account: $owner, strategyId: $strategyId }
      orderBy: createdAt
      orderDirection: desc
    ) {
      id
      strategyId
      action
      account
      strategyAmount
      marginAmount
      payoff
      createdAt
    }
  }
`

export type StrategyHistoryItems = {
  strategyUserHistoryItems: {
    id: string
    strategyId: string
    action: string
    account: string
    strategyAmount: string
    marginAmount: string
    payoff: string
    createdAt: string
  }[]
}
